import { createSelector as createReselectSelector } from 'reselect';
import { createSelector } from 'redux-orm';
import { orm } from 'model';
import { convertToDays } from '../util';

export const selectorCount = createSelector(
  orm,
  (state, props) => props,
  ({ ExternalAccountAudit }, { id }) =>
    ExternalAccountAudit.filter(({ extddaId }) => extddaId === id).count()
);

const selector = createSelector(
  orm,
  (state, props) => props,
  ({ ExternalAccountAudit }, { id }) =>
    ExternalAccountAudit.filter(
      ({ extddaId }) => extddaId === id
    ).toModelArray()
);

export const selectorGroupedByDays = createReselectSelector(selector, (items) =>
  items.reduce(convertToDays, [])
);
